import React, { Component } from "react";
import Modal from "react-responsive-modal";
import StatusSection from "../component/StatusSection";
import ActionSection from "../component/ActionSection";
import StatusIcon from "../component/StatusIcon";
import ActionButton from "../component/ActionButton";

/*import BuchungsstelleTable from "../component/BuchungsstelleTable";
import MainActionButton from "../component/MainActionButton";
import FaBriefcase from "react-icons/lib/fa/briefcase";*/
const colors = {
  inactive: "",
  active: "white",
  done: "#45c926"
};

const statusIconStyle = {
  maxWidth: "45px",
  maxHeight: "45px",
  width: "auto",
  height: "auto"
};

export default class FirstCase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      checked: false
    };
  }

  delete() {
    this.setState({ modal: false }, () => this.props.delete());
  }

  renderConfirmedSign(name, state) {
    switch (state) {
      case -1:
        return <p className="disconfirmed">{name + " ✖"}</p>;
      case 0:
        return <p className="uncomfirmed">{name + " ?"}</p>;
      case 1:
        return <p className="confirmed">{name + " ✔"}</p>;
      default:
        return null;
    }
  }
  /*
  renderModal() {
    let value =
      `Sehr geehrter Herr ` +
      this.props.case.contact +
      `,
wir mussten feststellen, dass Ihr Vertragskonto bei und noch nicht ausgeglichen ist.
Hiermit möchten wir Sie an den Ausgleich der fälligen Beträge in Höhe von ` +
      this.props.case.stats.total.value +
      `€ erinnern und Ihnen
die Gelegenheit geben, den Betrag schnell, einfach und sicher online per Direktüberweisung zu
bezahlen.

Vermeiden Sie unnötige Kosten und erledigen Sie es gleich.
Wir helfen Ihnen gerne dabei.`;
    return (
      <Modal
        open={this.state.modal}
        onClose={() => this.setState({ modal: false })}
        center
      >
        <div style={{ margin: "30px" }}>
          <p style={{ marginBottom: "10px" }}>
            {"Sende Email zu " +
              this.props.case.contact +
              " von " +
              this.props.case.name.value}
          </p>
          <textarea rows="10" cols="100" defaultValue={value} />
          <div>
            <span>
              {" "}
              <input
                style={{ height: "initial", width: "initial", float: "left" }}
                type="checkbox"
                onChange={event =>
                  this.setState({ checked: event.target.checked })
                }
              />
              <p style={{ float: "left" }}>Absenden bestätigen</p>
            </span>
            <button
              style={{ float: "right" }}
              onClick={() => this.delete()}
              disabled={!this.state.checked}
            >
              Email Senden
            </button>
          </div>
        </div>
      </Modal>
    );
  }*/

  renderBeg(beleg, index) {
    return (
      <tr>
        <td>{index + 1}</td>
        <td> 13/5567/12/124</td>
        <td> Vertragsdokumment</td>
        <td>Kommentar</td>
      </tr>
    );
  }
  renderBeleg(beleg, index) {
    //Eingangsdatum
    var dateFormat = require("dateformat");
    var eindat = new Date(this.props.case.sumf.value);
    var einsdatum = dateFormat(eindat, "dd.mm.yyyy");

    return (
      <tr>
        <td>1</td>
        <td> {this.props.case.id}</td>
        <td> {String(einsdatum)}</td>
        <td>{displayCurrency(this.props.case.sumg.value, "EUR", "de-DE")}</td>
      </tr>
    );
  }

  render() {
    let cCase = this.props.case;
    //fälligkeit
    var dateFormat = require("dateformat");
    var eindat = new Date(this.props.case.sumf.value);
    var raweindat = eindat.getTime() / (1000 * 3600 * 24);
    var roueindat = Math.round(raweindat);
    var rawfalldat = roueindat + 21;
    var falldat = rawfalldat * 1000 * 3600 * 24;
    var falldatum = dateFormat(falldat, "dd.mm.yyyy");
    // Tage überfällig
    var heute = new Date();
    var rawheute = heute.getTime() / (1000 * 3600 * 24);
    var fheute = Math.floor(rawheute);
    var tage = fheute - rawfalldat;
    var etage = tage > 0 ? tage : 0;

    return (
      <div className="caseContainerTemp">
        <div className="caseHeader">
          <p>
            <i>Rechnung </i>
            {cCase.id}
          </p>
          <p>
            <i></i>
          </p>
          <p>
            <i>Verantwortlicher</i> S. Seidel{" "}
          </p>
          {/* <span>{cCase.overdue + ' Tage überfällig'}</span> */}
          <p>{String(etage) + " Tage überfällig"}</p>
          <br />

          <p>
            <i>Bearbeitungszustand</i> {cCase.state}
          </p>
        </div>
        {/*<div
          className="importantNav"
          style={{
            width: "100%",
            height: "30",
            display: "block",
            paddingTop: 5,
            marginTop: 10,
            marginBottom: 10,
            alignItems: "center"
          }}
        >
          <div
            style={{
              width: "auto",
              height: "auto",
              alignSelf: "flex-end",
              display: "inline",
              float: "left"
            }}
          >
            <div style={{ marginBottom: 10 }}></div>
             <MainActionButton style={{marginBottom:10}}>
                <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'}}>
                <FaBriefcase/>
                  <p style={{marginLeft:10}}>
                    Zur Akte
                  </p>
                </div>
            </MainActionButton> 
          </div>

          <div style={{ float: "right" }}>
            {/* <MainActionButton style={{float:'right',alignItems:'center',justifyContent:'center',display:'flex'}}>
                <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',alignSelf:'flex-end',float:'right'}}>

                  <img src={require('../assets/icon/Folder.png')} style={{maxWidth:15,maxHeight:15}}/>
                  <p style={{marginLeft:10}}>
                    Logbuch anzeigen
                  </p>
              </div>
            </MainActionButton> 
          </div>
        </div>*/}

        <div
          className="caseState"
          style={{ alignItems: "center", marginTop: 5 }}
        >
          <StatusSection>
            <StatusIcon
              key={"1"}
              src={require("../assets/icon/WalletBlack.png")}
              style={statusIconStyle}
              doneColor={colors.done}
              activeColor="white"
              status={checkCaseKind(this.props.vkind)?"current":"done"}
              hasBar={true}
              name="fachlich richtig"
            />
            <StatusIcon
              key={"2"}
              src={require("../assets/icon/WalletBlack.png")}
              style={statusIconStyle}
              doneColor={colors.done}
              activeColor="white"
              status={checkCaseKind(this.props.vkind)?"active":"done"}
              hasBar={true}
              name="sachlich richtig"
            />
            <StatusIcon
              key={"3"}
              src={require("../assets/icon/Briefcase.png")}
              style={statusIconStyle}
              doneColor={colors.done}
              activeColor="white"
              status={checkCaseKind(this.props.vkind)?"active":"current"}
              hasBar={true}
              name="Rechnung richtig"
            />
            <StatusIcon
              key={"4"}
              src={require("../assets/icon/Hand ShakeActive.png")}
              style={statusIconStyle}
              doneColor={colors.done}
              activeColor="white"
              status="active"
              hasBar={true}
              name="Anordnung"
            />
            <StatusIcon
              key={"5"}
              src={require("../assets/icon/Combined ShapeBlack.png")}
              style={statusIconStyle}
              doneColor={colors.done}
              activeColor="white"
              status="active"
              hasBar={false}
              name="Abgeschlossen"
            />
          </StatusSection>

          <div className="actionSection" style={{ paddingTop: 5 }}>
            <ActionSection>
              <ActionButton
                text="Vorgang weitergeben"
                recommended={true}
                fat={true}
                action={() => {}}
              />
              <ActionButton
                text={checkCaseKind(this.props.vkind)?"Fachliche Richtigkeit":"Rechnerische Richtigkeit"}
                recommended={true}
                fat={true}
                action={() => {}}
              />
              {/* <ActionButton text="Einzahlen" action={()=>{}}/> 
              <div
                style={{
                  width: 100,
                  height: "auto",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid white",
                  color: "white",
                  padding: 5,
                  float: "right"
                }}
              >
                <p style={{ color: "white", fontSize: "12px", marginLeft: 10 }}>
                  Rechnerishe Richtigkeit
                </p>
                <img
                  src={require("../assets/icon/keyboard-right-arrow-button.png")}
                  style={{ maxWidth: 10, maxHeight: 10, marginLeft: 5 }}
                />
              </div>*/}
            </ActionSection>

            {/* <ActionSection>
              <ActionButton text="fachlich bestätigen" action={() => {}} />
              <ActionButton text="sachlich bestätigen" action={() => {}} />
              <ActionButton
                text="Rechnung bestätigen"
                recommended={true}
                action={() => {}}
              />
              <ActionButton
                text="Anordnung erteilen"
                action={() => {}}
                disabled={true}
              />
              <ActionButton
                text="Entfernen"
                action={() => this.props.delete()}
              />
              {/* <div style={{width:70,height:'auto',display:'flex',flexDirection:'row',alignItems:'center',jsutifyContent:'center',border:'1px solid white',color:'white',padding:5,float:'right'}}>
              <p style={{color:'white',fontSize:'12px',marginLeft:10}}>Weitere</p>
              <img src={require('../assets/icon/keyboard-right-arrow-button.png')} style={{maxWidth:10,maxHeight:10,marginLeft:5}}/>
            </div> 
            </ActionSection> */}
          </div>
        </div>

        <hr />

        <div className="sum">
          <span style={{ width: "23%" }}>
            <p></p>
            <p>{cCase.sumb.value}</p>
            <p className="un">{cCase.sumb.name}</p>
          </span>
          <span style={{ width: "23%" }}>
            <p></p>
            <p>
              {displayCurrency(
                cCase.sumg.value -
                  cCase.sumg.value * (cCase.stats.zinsen.perc / 100),
                "EUR",
                "de-DE"
              )}
            </p>
            <p className="un">{cCase.sumg.name}</p>
          </span>
          <span style={{ width: "23%" }}>
            <p></p>
            <p>{String(falldatum)}</p>
            <p className="un">Fälligkeit</p>
          </span>
          <span style={{ width: "23%" }}>
            <p></p>
            <p>{displayCurrency(cCase.sumg.value * 2, "EUR", "de-DE")}</p>
            <p className="un">Verfügbare Mittel</p>
          </span>
          <span style={{ width: "23%" }}>
            <p></p>
            <p>{cCase.stats.zinsen.perc}%</p>
            <p className="un">Skonto</p>
          </span>
          <span style={{ width: "23%" }}>
            <p></p>
            <p>
              {" "}
              {displayCurrency(
                cCase.sumg.value * (cCase.stats.zinsen.perc / 100),
                "EUR",
                "de-DE"
              )}
            </p>
            <p className="un">Skonto-Betrag</p>
          </span>
          <span style={{ width: "23%" }}>
            <p></p>
            <p>{cCase.mvo.value}</p>
            <p className="un">MVO</p>
          </span>
          <span style={{ width: "23%" }}>
            <p></p>
            <p>{cCase.vorsteuer.value}</p>
            <p className="un">Vorsteuer</p>
          </span>
        </div>

        <div className="routineMetaData">
          <div className="mdLeftBlock">
            <span>
              <p className="confirmed">Zahlungsempfänger</p>
              <p>{cCase.name.value}</p>
              <p>{"Vertreten durch: " + cCase.contact}</p>
            </span>
            <span>
              <p className="confirmed">Bankverbindung</p>
              <p>{cCase.banking.value}</p>
            </span>
            {/* <span>
              {this.renderConfirmedSign('Adresse', cCase.address.confirmed)}
              <p>{cCase.address.value}</p>
            </span>
            <span>
              {this.renderConfirmedSign('Email', cCase.email.confirmed)}
              <p>{cCase.email.value}</p>
            </span> */}
          </div>

          {/* <div className="notes">
            <p>Notizen</p>
            <br />
            <p>{cCase.notes[0].date}</p>
            <p>{cCase.notes[0].value}</p>
          </div> */}

          <div className="mdLeftBlock">
            <span>
              <p className="confirmed">Telefon</p>
              <p>{cCase.phone.value}</p>
            </span>
            <span>
              <p className="confirmed">Mobil</p>
              <p>{cCase.mobile.value}</p>
            </span>
            {/* <span>
              {this.renderConfirmedSign('Fax', cCase.fax.confirmed)}
              <p>{cCase.fax.value}</p>
            </span> */}
          </div>
          {/*
          <div className="mdLeftBlock">
            <span>
              <p className="confirmed">{"MVO"}</p>
              <p>{cCase.mvo.value}</p>
            </span>
            <span>
              <p className="confirmed">{"Vorsteuer"}</p>
              <p>{cCase.vorsteuer.value}</p>
            </span>
          </div>*/}
          <div>{/*<BuchungsstelleTable />*/}</div>
        </div>
        <div className="receipts">
          <p>Rechnung</p>
          <div className="receiptsTable">
            <table>
              <thead>
                <tr>
                  <td> Nr.</td>
                  <td> </td>
                  {/*<td> Belegname </td>*/}
                  <td> Eingangsdatum</td>
                  <td> Rechnungsbetrag </td>
                  <td>&nbsp;</td>
                </tr>
              </thead>
              <tbody>
                {this.renderBeleg()}
                {/*{cCase.belege.map((v, i) => {
                  return this.renderBeleg(v, i);
                })}*/}
              </tbody>
            </table>
          </div>
        </div>

        <div className="receipts">
          <p>Begründende Unterlagen</p>
          <div className="receiptsTablet">
            <table>
              <thead>
                <tr>
                  <td> Nr.</td>
                  <td> </td>
                  {/*<td> Belegname </td>*/}
                  <td> Kategorie</td>
                  <td> Kommentar </td>
                  <td className="plus">+</td>
                </tr>
              </thead>
              <tbody>
                {cCase.belege.map((v, i) => {
                  return this.renderBeg(v, i);
                })}
              </tbody>
            </table>
          </div>
        </div>
        {/*{this.renderModal()}*/}
      </div>
    );
  }
}
function displayCurrency(number, curr, locale) {
  if (locale === undefined) {
    locale = "en-US";
  }
  if (curr === undefined) {
    curr = "USD";
  }
  var formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: curr
  });
  return formatter.format(number);
}
function checkCaseKind(kindNum){
  if(kindNum === 2 || kindNum === 3){
    return true;
  } else {
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/component/FirstCase.js